import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { IMarker } from 'types/markerCore/marker-core-type.js';

export enum GENERATED_MODULES {
  WARNINGS_PANEL = 'warnings-panel',
  WARNINGS_LIST_NAME = 'warnings-list',
  MARKER_DESCRIPTION = 'marker-description',
  /** V2 we do not just merge marker data into map panel as we need seperation of concerns */
  MARKER_DESCRIPTION_NO_MERGE = 'marker-description/panel',
  STATION_DESCRIPTION = 'station-description',
  /** V2 we do not just merge marker data into map panel as we need seperation of concerns */
  STATION_DESCRIPTION_NO_MERGE = 'station-description/panel',
  MAP_SLOT = 'three-hourly-table-forecast/map-slot',
  MAP_SLOT_NO_MERGE = 'three-hourly-table-forecast/map-slot-panel',
}

export interface IMapModuleConfig extends IModuleConfig, IMapSlotClose {
  markers?: IMarker[];
}

export interface IWarningsPanelProps extends IMapModuleConfig {
  showCloseText?: boolean;
}
